"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBarConfigurationItem = void 0;
const react_1 = __importStar(require("react"));
const AppBarConfigurationItem_styles_1 = require("./AppBarConfigurationItem.styles");
const helpers_1 = require("../../../helpers");
const Icon_1 = require("../../../Icon");
const IconCloseConfiguration_1 = require("../../../icons/IconCloseConfiguration");
const IconConfiguration_1 = require("../../../icons/IconConfiguration");
const IconTriangleDown_1 = require("../../../icons/IconTriangleDown");
const StackView_1 = require("../../../StackView");
exports.AppBarConfigurationItem = (0, helpers_1.createUIElement)('AppBarConfigurationItem', (_a, ref) => {
    var { active, text = 'Configuration', url, className } = _a, rest = __rest(_a, ["active", "text", "url", "className"]);
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const handleMouseEnter = (0, react_1.useCallback)(() => {
        setIsHovered(true);
    }, []);
    const handleMouseLeave = (0, react_1.useCallback)(() => {
        setIsHovered(false);
    }, []);
    const dataSelectorId = (0, react_1.useMemo)(() => rest['data-selector-id'] || 'appbar-configuration-item', [rest]);
    const iconSrc = (0, react_1.useMemo)(() => (active && isHovered ? react_1.default.createElement(IconCloseConfiguration_1.IconCloseConfiguration, null) : react_1.default.createElement(IconConfiguration_1.IconConfiguration, null)), [active, isHovered]);
    return (react_1.default.createElement(AppBarConfigurationItem_styles_1.StyledAppBarConfigurationItem, Object.assign({}, rest, { ref: ref, href: url, active: active, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, "data-selector-id": dataSelectorId, className: (0, helpers_1.cn)('vm-AppBarConfigurationItem', className) }),
        react_1.default.createElement(StackView_1.StackView, { asTag: 'span', align: StackView_1.STACK_ALIGN.center, gap: StackView_1.STACK_GAP.s },
            react_1.default.createElement(Icon_1.Icon, { src: iconSrc, size: Icon_1.ICON_SIZES.xl }),
            react_1.default.createElement(AppBarConfigurationItem_styles_1.StyledAppBarConfigurationItemText, { asTag: 'span' }, text)),
        active && react_1.default.createElement(AppBarConfigurationItem_styles_1.StyledAppBarConfigurationItemTriangleIcon, { src: react_1.default.createElement(IconTriangleDown_1.IconTriangleDown, null) })));
});
//# sourceMappingURL=AppBarConfigurationItem.js.map